import { render, staticRenderFns } from "./BuildingBlueprintsView.vue?vue&type=template&id=a0369aa6"
import script from "./BuildingBlueprintsView.vue?vue&type=script&lang=ts"
export * from "./BuildingBlueprintsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports